// @greenlight-spec: 06-agent-interface.md
// @greenlight-spec: 28-it-dashboard-ui.md
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { AppCoOwnerSchema } from '@greenlight/shared';
import { AppIdParamsSchema, errorResponses } from './common.js';
const c = initContract();
const UserParamsSchema = AppIdParamsSchema.extend({ userId: z.string().uuid() });
export const AddCoOwnerSchema = z.object({
    email: z.string().email(),
});
export const coOwnersContract = c.router({
    list: {
        method: 'GET',
        path: '/api/apps/:id/co-owners',
        pathParams: AppIdParamsSchema,
        responses: {
            200: z.object({ items: z.array(AppCoOwnerSchema), group_members_truncated: z.boolean() }),
            ...errorResponses,
        },
        summary: 'List co-owners of an app.',
    },
    add: {
        method: 'POST',
        path: '/api/apps/:id/co-owners',
        pathParams: AppIdParamsSchema,
        body: AddCoOwnerSchema,
        responses: { 201: AppCoOwnerSchema, ...errorResponses },
        summary: 'Add a co-owner by email.',
    },
    remove: {
        method: 'DELETE',
        path: '/api/apps/:id/co-owners/:userId',
        pathParams: UserParamsSchema,
        body: c.noBody(),
        responses: { 204: c.noBody(), ...errorResponses },
        summary: 'Remove a co-owner from an app.',
    },
});
//# sourceMappingURL=coowners.js.map